import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import FormElement from "../components/FormBuilder/FormElement";
import {
  Grid,
  Button,
  Paper,
  Box,
  IconButton,
  Tooltip,
  Typography,
  StepLabel,
  Stepper,
  Step,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FormProvider } from "../FormContext";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import LoadingOverlay from "../components/loadingOverlay/LoadingOverlay";
import DraggableElement from "./DraggableElement";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { formElements } from "../store/formSlice";
import {
  fetchFormData,
  fetchSubContractorDetail,
  mergeElementsWithFormValues,
} from "../utils/formUtils";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CloseIcon from "@mui/icons-material/Close";
import "../App.css";
import { SIGNCONTRACTSTATUS, USERROLE } from "../utils/commonConstant";
import { fetchFromWebApi } from "../utils/fetchFromWebApi";
const FormFillPage = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const {
    clientId,
    documentType,
    subcontractorId,
    subcotractorTypeId,
    notificationScheduleId,
  } = useParams();
  const [loading, setLoading] = useState(false);
  const [iconVisible, setIconVisible] = useState(true);

  const formElementValues = useSelector(formElements);
  const [elements, setElements] = useState([]);
  const [isApprovedByClient, setIsApprovedByClient] = useState(false);
  const ToCaptureRef = useRef();
  const [activeStep, setActiveStep] = useState(0);
  const [steps, setSteps] = useState([]);

  const [elementsListData, setElementsListData] = useState([]);
  const [isSignBtnDisable, setIsSignBtnDisable] = useState(true);
  const [signDataListModel, setSignDataListModel] = useState([]);
  const [isFinshBtnClikced, setIsFinshBtnClikced] = useState(false);
  const [isSubcontractorSigned, setIsSubcontractorSigned] = useState(false);

  const handleNext = () => {
    mergeElementsWithFormValues(elements, formElementValues);
    const isValid = validateRequiredFields();
    if (!isValid) {
      const firstInvalidElement = elements.find(
        (element) => element.props.required && !element.props.value
      );
      const elementNode = document.getElementById(firstInvalidElement.id);
      if (elementNode) {
        elementNode.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      toast.error("Errors in Required Fields.");
      return;
    }
    console.log(activeStep, "activeStep");
    const updatedElements = {
      contractSignDocumentId: steps[activeStep]?.HHContractSignDocumentId,
      ContractId: steps[activeStep]?.Id,
      subcontractorId: subcontractorId, // Add new field with inputValue
      clientId: clientId,
      documentType: documentType,
      responseJson: elements,
      responseHtml: "",
      notificationScheduleId: notificationScheduleId,
    };
    setElementsListData([...elementsListData, updatedElements]);
    setElements([]);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    if (!iconVisible) {
      setIconVisible(true);
    }
  };
  const handleFinish = () => {
    mergeElementsWithFormValues(elements, formElementValues);
    const isValid = validateRequiredFields();
    if (!isValid) {
      const firstInvalidElement = elements.find(
        (element) => element.props.required && !element.props.value
      );
      const elementNode = document.getElementById(firstInvalidElement.id);
      if (elementNode) {
        elementNode.scrollIntoView({ behavior: "smooth", block: "center" });
        elementNode.focus();
      }
      toast.error("Errors in Required Fields.");
      return;
    }
    alert(
      "All steps is completed! (Please Click Sign Contract for further process)"
    );
    const updatedElements = {
      contractSignDocumentId: steps[activeStep]?.HHContractSignDocumentId,
      ContractId: steps[activeStep]?.Id,
      subcontractorId: subcontractorId, // Add new field with inputValue
      clientId: clientId,
      documentType: documentType,
      responseJson: elements,
      responseHtml: "",
      notificationScheduleId: notificationScheduleId,
    };
    setElementsListData([...elementsListData, updatedElements]);
    setIsSignBtnDisable(false);
    setIsFinshBtnClikced(true);
  };

  const handleBack = () => {
    setActiveStep(0);
    setIsSignBtnDisable(true);
    setElementsListData([]);
    if (!iconVisible) {
      setIconVisible(true);
    }
  };

  const insertInlineCSS = () => {
    console.log("CSS insert invoked");
    const trackChangesClass = document.querySelectorAll(
      ".track-changes.added,.track-changes.deleted,.track-changes.modified"
    );
    if (trackChangesClass.length > 0) {
      console.log(trackChangesClass, "trackChangesClassAdded");
      trackChangesClass.forEach((element) => {
        // element.style.backgroundColor = "white";
        // element.style.textDecoration = "none";
        element.classList.remove("track-changes");
      });
    }
    const commentClass = document.querySelectorAll(".selection-highlight");
    if (commentClass.length > 0) {
      commentClass.forEach((element) => {
        // element.style.backgroundColor = "white";
        // element.style.cursor = "none";
        element.classList.remove("selection-highlight");
      });
    }
  };
  useEffect(() => {
    if (steps.length > 0) {
      setElements(steps[activeStep]?.MetaData);
      setIsApprovedByClient(
        steps[activeStep]?.COApprovalStatus === "Approved" ? true : false
      );
      setIsSubcontractorSigned(
        steps[activeStep]?.HHContractSignStatus === SIGNCONTRACTSTATUS.SIGNED
          ? true
          : false
      );
    }
  }, [steps, activeStep]);

  useEffect(() => {
    console.log(elementsListData, "elementsListData");
    setSignDataListModel(elementsListData);
  }, [elementsListData]);
  console.log(signDataListModel, "signDataListModel");

  useEffect(
    () => {
      // if(isApprovedByClient){
      const handleLoad = () => {
        setTimeout(() => {
          if (elements.length > 0) {
            insertInlineCSS();
          }
        }, 1000); // 1 second delay
      };

      // Listen for the window load event to ensure the page is fully rendered
      if (document.readyState === "complete") {
        handleLoad(); // Page is already loaded
      } else {
        window.addEventListener("load", handleLoad); // Wait for the load event
      }

      // Cleanup the event listener on unmount
      return () => {
        window.removeEventListener("load", handleLoad);
      };
    },
    // }
    [elements, isApprovedByClient]
  );

  useEffect(() => {
    if (isSubcontractorSigned) {
      navigate("/already-signed");
    }
  }, [isSubcontractorSigned]);

  const validateRequiredFields = () => {
    let isValid = true;

    const updatedElements = elements.map((element) => {
      if (element.props.required && !element.props.value) {
        isValid = false;
        return {
          ...element,
          props: {
            ...element.props,
            error: true,
            helperText: "This field is required",
          },
        };
      }
      return {
        ...element,
        props: {
          ...element.props,
          error: false,
          helperText: "",
        },
      };
    });
    setElements(updatedElements);
    return isValid;
  };
  const fieldMappings = {
    SubcontractorName: "SubcontractorName",
    FirstName: "FirstName",
    LastName: "LastName",
    Email: "Email",
    PersonalNo: "MobileNumber",
    Mobile: "MobileNumber",
    Address: "AddressLine1",
    City: "City",
    RecipientRole: "Subcontractor",
    Zipcode: "Postcode",
  };

  const processElement = (element, subcontractorDetail) => {
    if (element.type !== "textField") return element;

    const detailKey = fieldMappings[element.props.selectedField];
    if (detailKey) {
      return {
        ...element,
        props: {
          ...element.props,
          value: subcontractorDetail[detailKey] || element.props.value,
        },
      };
    }
    return element;
  };

  const processList = (list, subcontractorDetail) =>
    list.map((item) => {
      if (item.items) {
        return { ...item, items: processList(item.items, subcontractorDetail) };
      }
      return processElement(item, subcontractorDetail);
    });

  const updateElementsWithDetails = async (element) => {
    const subcontractorDetail = await fetchSubContractorDetail(
      clientId,
      subcontractorId
    );
    if (!subcontractorDetail) return;

    const mergedElements = processList(element, subcontractorDetail);
    setSteps(mergedElements);
  };

  const handleCloseClick = () => {
    setIconVisible(false);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const res = await fetchFromWebApi(
        `SignHHManagerDocument`,
        {
          method: "POST",
          body: JSON.stringify(signDataListModel),
        }
      );
      setLoading(false);
      if (res?.ok) {
        const responseData = await res.json();
        if (responseData.Success) {
          navigate("/thank-you");
        } else {
          toast.success(responseData.Message || "Failed to sign contract");
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error while saving form:", error);
      toast.error("Error while signing contract:", error);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const [formData, subcontractorDetail] = await Promise.all([
        fetchFormData(
          clientId,
          documentType,
          subcotractorTypeId,
          notificationScheduleId
        ),
        fetchSubContractorDetail(clientId, subcontractorId),
      ]);

      if (!formData || !subcontractorDetail) return;
      if (subcontractorDetail.ClientAddress) {
        subcontractorDetail.ClientAddress = subcontractorDetail.ClientAddress.replace(/\n/g, ", ");
      }
      const sortedFormData =
        formData.length > 1
          ? formData.sort((a, b) => a.DisplayOrder - b.DisplayOrder)
          : formData;

      const processParagraphText = (
        text,
        inlineFields,
        subcontractorDetail,
        fieldMappings
      ) => {
        // Use DOMParser to parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        inlineFields.forEach((inlineField) => {
          const detailKey = fieldMappings[inlineField.mappingField];
          if (detailKey) {
            const newValue = subcontractorDetail[detailKey] || "";

            // Find the element by data-uuid
            const element = doc.querySelector(
              `[data-uuid="${inlineField.uuid}"]`
            );
            if (element) {
              // Update the data-default-value attribute
              element.setAttribute("data-default-value", newValue);
            }
            inlineField.value = newValue;
          }
        });
        return doc.body.innerHTML;
      };
      const processElement = (element) => {
        const fieldMappings = {
          SubcontractorName: "SubcontractorName",
          FirstName: "FirstName",
          LastName: "LastName",
          Email: "Email",
          PersonalNo: "MobileNumber",
          Mobile: "MobileNumber",
          Address: "AddressLine1",
          City: "City",
          RecipientRole: "Subcontractor",
          Zipcode: "Postcode",
          ClientName: "ClientName",
          ClientAddress: "ClientAddress",
        };
        // Process paragraph elements
        if (
          element.type === "paragraph" &&
          element.props.inlineFields &&
          element.props.inlineFields.length > 0
        ) {
          const updatedText = processParagraphText(
            element.props.text,
            element.props.inlineFields,
            subcontractorDetail,
            fieldMappings
          );
          return {
            ...element,
            props: {
              ...element.props,
              text: updatedText,
              inlineFields: element.props.inlineFields,
            },
          };
        }
        if (element.type !== "textField") return element;

        const detailKey = fieldMappings[element.props.selectedField];
        if (detailKey) {
          return {
            ...element,
            props: {
              ...element.props,
              value: subcontractorDetail[detailKey] || element.props.value,
            },
          };
        }
        return element;
      };

      const processList = (list) =>
        list.map((item) => {
          if (item.MetaData) {
            return { ...item, MetaData: processList(item.MetaData) };
          }
          return processElement(item);
        });

      const mergedElements = processList(sortedFormData);
      setSteps(mergedElements);
    }

    fetchData();
  }, [clientId, subcontractorId]);
  console.log(steps, "Steps");
  const scrollToSection = () => {
    const element = document.getElementById("btnSignature");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      toast.error("Signature not found");
    }
  };
  return (
    <FormProvider>
      <Box position="relative" minHeight="100vh">
        <Grid
          container
          justifyContent="center"
          ref={ToCaptureRef}
          sx={{
            backgroundColor: isMobile ? "#FFFFFF" : "#CCCCCC",
          }}
        >
          <Grid item xs={12} md={8}>
            <DndContext autoScroll={false} collisionDetection={closestCenter}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "center",
                }}
              >
                <Grid container spacing={isMobile ? 1 : 2}>
                  <Grid item xs={12}>
                    <Paper
                      elevation={3}
                      sx={{
                        padding: isMobile ? 1 : 2,
                        minHeight: isMobile ? "500px" : "700px",
                      }}
                    >
                      <Grid container spacing={2}>
                        {/* Stepper Area */}
                        <Grid item xs={12}>
                          <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((step, index) => (
                              <Step key={index}>
                                <StepLabel>{step.VersionName}</StepLabel>
                              </Step>
                            ))}
                          </Stepper>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          position="fixed"
                          sx={{
                            display: "flex",
                            mt: 3,
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            right: isMobile ? 10 : 300,
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                            border: "1px solid",
                            borderColor: "primary.main",
                            borderRadius: "8px",
                            padding: "10px",
                            visibility: iconVisible ? "visible" : "hidden",
                          }}
                        >
                          <Tooltip title="CLICK TO SIGN" arrow>
                            <IconButton
                              color="primary"
                              onClick={() => {
                                scrollToSection();
                              }}
                              size="large"
                            >
                              <ArrowDownwardIcon
                                sx={{ fontSize: isMobile ? 80 : 110 }}
                              />
                            </IconButton>
                          </Tooltip>
                          <Typography>CLICK TO SIGN</Typography>

                          <IconButton
                            onClick={handleCloseClick}
                            size="small"
                            sx={{
                              position: "absolute",
                              top: -10,
                              right: -5,
                              color: "grey",
                            }}
                          >
                            <CloseIcon sx={{ fontSize: isMobile ? 25 : 35 }} />
                          </IconButton>
                        </Grid>
                        <SortableContext
                          items={elements}
                          strategy={verticalListSortingStrategy}
                        >
                          {elements.map((element, index) => {
                            return (
                              <Grid
                                className={
                                  element.type === "paragraph"
                                    ? "dndElementParagraph"
                                    : "dndElement"
                                }
                                xs={12}
                                item
                                key={element.id}
                                sx={{
                                  ...(element.type === "signature" ||
                                    element.type === "fileUpload"
                                    ? { pageBreakInside: "avoid" }
                                    : {}),
                                  ...(element.type === "logo" && {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }),
                                }}
                              >
                                <DraggableElement id={element.id} index={index}>
                                  <FormElement
                                    element={element}
                                    dragHandle={false}
                                    formPreview={true}
                                    trackChangeDisplayBy={
                                      USERROLE.SUBCONTRACTOR
                                    }
                                  />
                                </DraggableElement>
                              </Grid>
                            );
                          })}
                        </SortableContext>

                        {/* Buttons Area */}
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: isMobile ? "column" : "row",
                              gap: 1,
                              justifyContent: "space-between",
                            }}
                          >
                            <Button
                              disabled={activeStep === 0}
                              onClick={handleBack}
                              variant="contained"
                              color="primary"
                            >
                              Back
                            </Button>
                            {activeStep === steps.length - 1 ? (
                              <Button
                                disabled={isFinshBtnClikced}
                                onClick={handleFinish}
                                variant="contained"
                                color="primary"
                              >
                                Finish
                              </Button>
                            ) : (
                              <Button
                                onClick={handleNext}
                                variant="contained"
                                color="primary"
                              >
                                Next
                              </Button>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </DndContext>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginTop: "20px",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                padding: { xs: "12px 18px", sm: "14px 20px", md: "16px 24px" },
              }}
              onClick={handleSign}
              disabled={isSignBtnDisable}
            >
              Sign Contract
            </Button>
          </Grid>
        </Grid>
        <LoadingOverlay open={loading} />
      </Box>
    </FormProvider>
  );
};

export default FormFillPage;
